import client from './client';
import { SellerAccount, SellerProfile } from '../types';

export const login = async (username: string, password?: string) => {
    // Determine if it is a seller login (with password) or potentially other type
    // But our backend has /auth/login for username/password
    const { data } = await client.post('auth/login', { username, password });
    return data;
};

export const kakaoLogin = async (kakaoAccessToken: string) => {
    const { data } = await client.post('auth/kakao-login', { kakaoAccessToken });
    return data;
};

export const getKakaoToken = async (code: string) => {
    const params = new URLSearchParams();
    params.append('grant_type', 'authorization_code');
    params.append('client_id', import.meta.env.VITE_KAKAO_API_KEY);
    params.append('redirect_uri', window.location.origin);
    params.append('code', code);

    const clientSecret = import.meta.env.VITE_KAKAO_CLIENT_SECRET;
    if (clientSecret) {
        params.append('client_secret', clientSecret);
    }

    const response = await fetch('https://kauth.kakao.com/oauth/token', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
        },
        body: params,
    });

    if (!response.ok) {
        throw new Error('Failed to get Kakao token');
    }

    return response.json();
};

export const registerSeller = async (username: string, password?: string) => {
    const { data } = await client.post('auth/register-seller', { username, password });
    return data;
};

export const getSellers = async (): Promise<SellerAccount[]> => {
    const { data } = await client.get('auth/sellers');
    return data;
};

export const updateSellerPasswordByAdmin = async (sellerId: string, newPassword: string) => {
    const { data } = await client.patch(`auth/sellers/${sellerId}/password`, { newPassword });
    return data;
};

export const deleteSellerAccount = async (sellerId: string) => {
    const { data } = await client.delete(`auth/sellers/${sellerId}`);
    return data;
};

export const getProfile = async () => {
    const { data } = await client.get('auth/profile');
    return data;
};

export const updateProfile = async (updates: { name?: string; phone?: string }) => {
    // Map frontend 'phone' to backend 'phoneNumber'
    const backendUpdates: any = {};
    if (updates.name !== undefined) backendUpdates.name = updates.name;
    if (updates.phone !== undefined) backendUpdates.phoneNumber = updates.phone;

    const { data } = await client.patch('auth/profile', backendUpdates);
    return data;
};

export const getSellerProfile = async (): Promise<SellerProfile> => {
    const { data } = await client.get('auth/seller-profile');
    return data;
};

export const updateSellerProfile = async (updates: { businessName?: string; image?: string | null; shareDescription?: string | null; storeAddress?: string; storeContact?: string }): Promise<SellerProfile> => {
    const { data } = await client.patch('auth/seller-profile', updates);
    return data;
};

export const changeSellerPassword = async (currentPassword: string, newPassword: string) => {
    const { data } = await client.patch('auth/seller-password', { currentPassword, newPassword });
    return data;
};

export const impersonate = async (userId: string) => {
    const { data } = await client.post('auth/impersonate', { userId });
    return data;
};
